


// ———————————————
// TRT (Testosterone Replacement Therapy)
// ———————————————
const heroTRT      = "https://i.postimg.cc/ZKKhzb6w/i-Stock-2135022914.webp";
const collageTRTCombined  = "https://i.postimg.cc/0Ncm5gnG/Mix-Collage-24-Apr-2025-09-19-PM-3010.webp";
const treatmentTRT = "https://i.postimg.cc/placeholder3.jpg";

// ———————————————
// HRT (Hormone Replacement Therapy)
// ———————————————
const heroHRT      = "https://i.postimg.cc/placeholder4.jpg";
const collageHRTCombined  = "https://i.postimg.cc/3rSZ3GN4/Mix-Collage-24-Apr-2025-10-07-PM-5584.webp";
const treatmentHRT = "https://i.postimg.cc/placeholder7.jpg";

// ———————————————
// ED (Erectile Dysfunction Treatment)
// ———————————————
const heroED       = "https://i.postimg.cc/placeholder8.jpg";
const collageEDCombined  = "https://i.postimg.cc/ydr78j2r/Mix-Collage-24-Apr-2025-09-37-PM-7867.jpg";
const treatmentED  = "https://i.postimg.cc/placeholder11.jpg";

// ———————————————
// Peptide Therapy
// ———————————————
const heroPeptide       = "https://i.postimg.cc/placeholder12.jpg";
const collagePeptideCombined   = "https://i.postimg.cc/q7NTZyNs/Mix-Collage-24-Apr-2025-09-55-PM-7974.webp";
const treatmentPeptide  = "https://i.postimg.cc/placeholder15.jpg";

// ———————————————
// PRP Therapy
// ———————————————
const heroPRP       = "https://i.postimg.cc/placeholder16.jpg";
const collagePRPCombined   = "https://i.postimg.cc/B6X2bqm5/Mix-Collage-24-Apr-2025-10-12-PM-7365.webp";
const treatmentPRP  = "https://i.postimg.cc/placeholder19.jpg";

// ———————————————
// Pain Management
// ———————————————
const heroPain      = "https://i.postimg.cc/placeholder20.jpg";
const collagePMCombined  = "https://i.postimg.cc/D0FRFXwY/Mix-Collage-24-Apr-2025-10-00-PM-2728.webp";
const treatmentPain = "https://i.postimg.cc/placeholder23.jpg";

// ———————————————
// Semaglutide Weight Loss Program
// ———————————————
const heroWLP       = "https://i.postimg.cc/placeholder24.jpg";
const collageSemaCombined   = "https://i.postimg.cc/W1XNysXv/Mix-Collage-24-Apr-2025-09-47-PM-8711.webp";
const treatmentWLP  = "https://i.postimg.cc/placeholder27.jpg";



// src/data/servicesData.js

export const servicesData = {
"testosterone-replacement-therapy": {
  title: "Testosterone Replacement Therapy",
  heroSubtitle: "Learn how we can help you get your energy, motivation, and sex drive back!",
  titleAbr: "TRT",
  shortDescription: `Testosterone is a hormone primarily produced in the testicles once males begin puberty. Production naturally declines about 1% per year after 30, but some men experience far more rapid drops, leading to symptoms like low libido, fatigue, and muscle loss. Pure Health & Wellness offers expert testosterone replacement therapy across California, including Fresno, Los Angeles, Bakersfield, and more.`,
  images: {
    hero: "https://res.cloudinary.com/djtsuktwb/image/upload/f_auto,q_auto,w_600/v1747966750/iStock-2135022914_icxnzb.jpg",
    desktopHero: "https://i.postimg.cc/T340Xpdq/i-Stock-2201828485.webp"
  },
  collageImage: collageTRTCombined,
  introTitle: "(TRT)Testosterone Replacement Therapy",
  introText: `Testosterone is a hormone that is primarily produced in the testicles of males once they begin puberty, and that production continues throughout the majority of their adult life. Most men naturally begin to produce roughly 1% less testosterone every year after they turn 30, however, some men lose testosterone at a much more rapid rate. For these men who are experiencing low testosterone, also known as hypogonadism, the condition can be exacerbated by conditions such as diabetes or obesity.`,
  extendedIntroText: `It is important to determine if a patient’s low testosterone is due to normal aging or if it is due to hypogonadism before beginning treatment. Men with hypogonadism can greatly benefit from testosterone replacement therapy and many will begin to see results in as little as 3 to 6 weeks. If you think this hormone replacement therapy might work for you, reach out to our team today to see if you qualify for testosterone replacement therapy and learn how we can help you get your energy, motivation, and sex drive back!`,
  causes: [
    {
      title: "Primary Hypogonadism",
      items: [
        "Undescended Testicles",
        "Hereditary Hemochromatosis",
        "Klinefelter’s Syndrome",
        "Extreme physical injury to the testicles",
        "Orchitis",
        "Cancer treatment"
      ]
    },
    {
      title: "Secondary Hypogonadism",
      items: [
        "Pituitary disorders",
        "Kallmann’s Syndrome",
        "Inflammatory diseases",
        "HIV/AIDS",
        "Certain medications",
        "Obesity",
        "Aging"
      ]
    }
  ],
  symptoms: [
    "Low libido (low sex drive)",
    "Erectile dysfunction",
    "Fatigue",
    "Low energy levels",
    "Anemia (low iron levels)",
    "Decreased muscle mass",
    "Lack of or loss of body and facial hair",
    "Difficulty concentrating",
    "Depression",
    "Irritability",
    "Low self-esteem",
    "Increased weight gain"
  ],
  treatment: {
    heading: "Individualized Treatment for Best Results",
    body: `Every man is different, so no two treatment paths are going to be exactly the same. We take the time to understand your unique situation and the underlying conditions that are contributing to your low testosterone. By working with you one-on-one at our men’s (TRT)testosterone clinic, we can help create the perfect treatment plan for you that will have you feeling young, strong, healthy, and virile again in no time. We’ll get you scheduled for labs at your earliest convenience.`,
    image: treatmentTRT
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
}
,


"hormone-therapy-for-women": {
  title: "Hormone Therapy for Women",
  heroSubtitle: "We are here to help you feel your best and be the healthiest version of yourself.",
  titleAbr: "HRT",
  shortDescription: `Hormone Replacement Therapy helps restore natural hormone balance to relieve symptoms like fatigue, mood swings, hot flashes, and low libido.`,
  images: {
    hero: "https://res.cloudinary.com/djtsuktwb/image/upload/f_auto,q_auto,w_600/v1747964123/iStock-2045082706_gu4dec.jpg",
    desktopHero: "https://i.postimg.cc/gjmQ6n6L/i-Stock-1128929966.webp"
  },
  collageImage: collageHRTCombined,
  introTitle: "Hormone Therapy: Helping You Feel Like You Again",
  introText: `When you’re dealing with hormone changes, it can be hard to feel like yourself. Some women feel as if they aren’t as in control of their moods or emotions as they were in the past, and it can be frustrating to put in work to take control of your health, only to feel like you’re a victim to the whims of your hormones.`,
  extendedIntroText: `With hormone therapy, your body will get safe, medically researched doses of synthetic hormones that can help you begin to feel like your normal self. When you’re going through HRT, it’s important that you stay in communication with your doctor so that adjustments can be made to your dosage as necessary. Sometimes, it can take some time to figure out the exact dosage of hormones that are needed to address your hormonal imbalance. Together, you and your doctor will find the hormone therapy dosage that makes the most sense for your hormone imbalance.

The goal of this treatment is to relieve menopausal symptoms, including weight gain, hot flashes, irregular periods, night sweats, mood changes, sleep problems.`,


  // new section:
  differenceTitle: "Hormone Imbalance Vs. Balance: What's The Difference?",
  differenceText: [
    `For many women, hormone imbalances are an inevitable part of getting older. After menopause, the body produces far less estrogen than before, and this can cause many unpleasant changes in the body that can negatively affect the quality of life. Some people find that their hormones cause adrenal gland issues, pituitary gland issues, thyroid gland problems, as well as serious hormone-related conditions like polycystic ovary syndrome.`,
    `Thankfully, it’s possible to use hormone therapy to balance your hormones in a way that stops the negative effects of changing hormones as you get older. Hormone replacement therapy can help you feel like yourself again.`,
    `Some women feel that declining energy and negative sex drive changes are just a part of growing older, but it doesn’t have to be that way. Advances in medicine have made it so that you likely don’t have to struggle through menopause the same way your mother and grandmother did. Thankfully, working closely with a physician who prescribes HRT can help you get the relief that you need from the symptoms of menopause.`,
    `When you balance your hormone levels through hormone therapy, you won’t just find that your health conditions are getting better–you’ll also likely find that the other symptoms of perimenopause and menopause decrease. Menopausal symptoms can be exhausting and frustrating, and there’s nothing wrong with taking charge of your health by giving hormone therapy a try.`,
    `If you’re considering hormone therapy, it’s likely that you’ve already tried other methods of correcting hormone imbalances, such as eating a healthy diet, taking control of your blood sugar, and getting medical education on why your changing hormones are negatively affecting your life. Women’s health can be complicated, and it can feel frustrating when you’re not seeing the changes you want despite your best efforts.`,
    `Before you begin addressing your hormonal imbalances with hormone replacement therapy, your doctor will talk with you about your symptoms. This can help rule out an underlying condition that isn’t related to hormonal problems.`,
    `Together, you and your physician will work to learn more about your health, and develop a health care plan that will help get your hormones in order. If you find that there isn’t an underlying cause unrelated to hormones that are causing your symptoms, your health care plan may include hormone replacement therapy or HRT. Typically, HRT involves supplementing your body’s estrogen and progestogen levels, as these are the two hormones that typically dip as the body goes through menopause. For most women, taking hormone replacement therapy is as simple as taking a pill every day.`
  ],
  differenceBullets: [
    "Better sleep quality",
    "Higher energy levels",
    "Enhanced Mood",
    "Increased Sex Drive",
    "Improved Heart And Vascular Health"
  ],


  causes: [
    {
      title: "Common Causes of Hormonal Imbalance in Women",
      items: [
        "Perimenopause and Menopause",
        "Post-pregnancy hormone shifts",
        "Thyroid dysfunction",
        "Adrenal fatigue",
        "Polycystic Ovary Syndrome (PCOS)",
        "Chronic stress or insomnia"
      ]
    }
  ],
  symptoms: [
    "Hot flashes and night sweats",
    "Mood swings or irritability",
    "Brain fog or memory issues",
    "Sleep disturbances",
    "Fatigue and low energy",
    "Vaginal dryness",
    "Low libido",
    "Weight gain or bloating",
    "Hair thinning",
    "Anxiety or mild depression"
  ],
  treatment: {
    heading: "Personalized HRT Plans",
    body: `Our providers design customized HRT protocols using bioidentical hormones and precise dosing to help you regain vitality, mental clarity, and overall well-being. Through lab testing and ongoing monitoring, we adjust your plan to optimize your body's natural rhythm. Most patients report significant improvements in symptoms within weeks of starting treatment.`,
    image: "https://via.placeholder.com/600x400?text=Treatment+Image"
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
},


"erectile-dysfunction-treatment": {
  title: "Erectile Dysfunction Treatment Clinic",
  heroSubtitle: "Learn how we can help you get your energy, motivation, and sex drive back!",
  titleAbr: "ED",
  shortDescription: `Our advanced ED treatments—including medications, injections, and shockwave therapy—help you regain sexual performance and confidence.`,
  images: {
    hero: "https://res.cloudinary.com/djtsuktwb/image/upload/f_auto,q_auto,w_600/v1747977323/iStock-940674076_rh9nwn.jpg",
    desktopHero: "https://i.postimg.cc/BbmYLN0R/i-Stock-1400269483.webp"
  },
  collageImage: collageEDCombined,
  introTitle: "Erectile Dysfunction Treatment",
  introText: `Erectile dysfunction, more commonly referred to as ED, is a common health condition that impacts men’s ability to achieve or maintain erections suitable for sexual intercourse. Research estimates that 1 in 10 men experience chronic erectile dysfunction severe enough to seek treatment while 52% of men experience at least one instance of erectile dysfunction in their lives. Men who only rarely experience erectile dysfunction, less than 20% of the time, which can be linked to heightened stress, instability in a relationship, or other temporary difficulties should not be concerned and generally do not need to seek treatment. For men who frequently have difficulty getting an erection during sexual interactions, or for those who are able to get an erection but cannot maintain it at least 50% of the time, treatment options are available at erectile dysfunction treatment centers. Chronic erectile dysfunction can cause severe mental and emotional distress to men if left untreated. If you are struggling with ED symptoms, don’t wait any longer to seek help for your condition: you need an erectile dysfunction doctor. Non-invasive treatment options are available that can restore your ability to get and maintain erections in as little as six weeks.`,
  causes: [
    {
      title: "Common Causes of Erectile Dysfunction",
      items: [
        "Diabetes and cardiovascular disease",
        "Hormonal imbalances (low testosterone)",
        "Anxiety, stress, or depression",
        "Side effects of medications",
        "Smoking and alcohol use",
        "Poor blood circulation"
      ]
    }
  ],
  symptoms: [
    "Difficulty achieving or maintaining an erection",
    "Reduced sexual desire",
    "Ejaculation issues",
    "Performance anxiety",
    "Relationship stress or dissatisfaction"
  ],
  treatment: {
    heading: "Advanced ED Therapies",
    body: `We provide a range of safe and effective treatment options for ED, including:

- ✅ Oral medications (PDE5 inhibitors)
- ✅ Penile injections or suppositories
- ✅ Acoustic shockwave therapy
- ✅ Testosterone replacement (if needed)
- ✅ Counseling or lifestyle recommendations

All treatments are tailored to your unique situation with discretion and support from experienced medical providers.`,
    image: "https://via.placeholder.com/600x400?text=ED+Treatment"
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
},



"benefits-of-peptide-therapy": {
  title: "The Benefits of Peptide Therapy",
  heroSubtitle: "From neuropeptides in the brain to peptides in the immune system, there’s virtually no area of the body that can’t benefit from peptide treatments.",
  titleAbr: "Peptides",
  shortDescription: `Targeted peptide protocols to support muscle growth, fat loss, immune health, and healthy aging—customized to your goals.`,
  images: {
    hero: "https://res.cloudinary.com/djtsuktwb/image/upload/f_auto,q_auto,w_600/v1747977752/iStock-487589082_ccbrfi.jpg",
    desktopHero: "https://i.postimg.cc/kgLnRvMV/i-Stock-2189199609.webp"
  },
  collageImage: collagePeptideCombined,
  introTitle: "What is Peptide Therapy?",
  introText: `Peptide therapies are now growing more and more common and for good reason. Peptides are some of the most important hormones in the body, and without them, it would be impossible to experience full and better health.`,
  extendedIntroText: `From improving skin health to providing instructions for the body to function, there’s no limit to what peptides can do. Unfortunately, a person’s number of peptides can be significantly lower than average, especially during older age or due to a number of other health conditions.

People can experience the benefits of better health, increased muscle mass, help with biological functions, and so much more with therapeutic peptides.`,
  causes: [
    {
      title: "Why Consider Peptide Therapy?",
      items: [
        "Decreased natural growth hormone levels",
        "Low energy or slow recovery after workouts",
        "Chronic inflammation or poor immune function",
        "Hormonal imbalances and aging",
        "Reduced cognitive clarity or focus"
      ]
    }
  ],
  symptoms: [
    "Fatigue and brain fog",
    "Difficulty building or maintaining muscle",
    "Weight gain or belly fat",
    "Slow healing or frequent illness",
    "Decreased libido",
    "Wrinkles and signs of aging"
  ],
  treatment: {
    heading: "Targeted Peptide Protocols",
    body: `Our medical team offers advanced peptide solutions including:

- ✅ CJC-1295 & Ipamorelin (for growth hormone support)
- ✅ BPC-157 (for tissue healing and gut repair)
- ✅ Semaglutide or AOD-9604 (for fat loss and appetite control)
- ✅ Thymosin Alpha-1 (for immune system regulation)

Each plan is personalized based on lab work, lifestyle goals, and optimal dosing to help you safely enhance vitality, longevity, and performance.`,
    image: "https://via.placeholder.com/600x400?text=Peptide+Treatment"
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
},

"platelet-rich-plasma-treatment": {
  title: "Platelet Rich Plasma Therapy",
  heroSubtitle: "Promote healing using your body’s own regenerative power.",
  titleAbr: "PRP",
  shortDescription: `PRP therapy uses your own growth factors to accelerate healing, reduce pain, and regenerate tissue naturally.`,
  images: {
    hero: "https://res.cloudinary.com/djtsuktwb/image/upload/f_auto,q_auto,w_600/v1747977524/iStock-2185379954_qse2an.jpg",
    desktopHero: "https://i.postimg.cc/B6rnFWT1/i-Stock-846081796.webp"
  },
  collageImage: collagePRPCombined,
  introTitle: "Platelet Rich Plasma Treatments",
  introText: `Platelet rich plasma treatments use your plasma to promote healing and repair. PRP contains millions of platelets and tiny cell fragments in the blood that form clots to stop bleeding.`,
  extendedIntroText: `When you have an injury, your body’s natural response is to use platelets to seal wounds. Platelets release growth factors that stimulate tissue regeneration, helping injured tissue heal more quickly. Platelet rich plasma therapy uses the same mechanisms.`,
  causes: [],
  symptoms: [],
  treatment: {
    heading: "About Platelet Rich Plasma Therapy",
    body: `Platelet rich plasma therapy uses the patient’s blood to:

- ✅ **Promote healing**
- ✅ **Treat torn tendons**
- ✅ **Treat joint injuries**

By using a concentrated dose of platelets from your own body, PRP stimulates natural repair and regeneration in a way that is safe, minimally invasive, and effective.`,
    image: "https://via.placeholder.com/600x400?text=PRP+Treatment"
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
},






"semaglutide-weight-loss-program": {
  title: "Semaglutide Weight Loss Program",
  heroSubtitle: "Are you ready to achieve real, sustainable weight loss? Starting at just $229/Month!",
  titleAbr: "Semaglutide",
  shortDescription: `Our medically supervised semaglutide program helps patients lose weight safely, reduce appetite, and improve metabolic health.`,
  images: {
    hero: "https://i.postimg.cc/zvRL7Cpc/i-Stock-2185447936-1-1.webp", // Replace with actual hero image variable
    desktopHero: "https://res.cloudinary.com/djtsuktwb/image/upload/v1749869528/iStock-498812823_1_vjh68d.jpg"
  },
  collageImage: collageSemaCombined,
  introTitle: "Semaglutide Weight Loss Program",
  introText: `With Semaglutide, the FDA-approved breakthrough in weight management, you can start seeing results safely and effectively—all starting at only $229 per month! No contracts or long term commitments!`,
  causes: [
    {
      title: "Why Weight Gain Happens",
      items: [
        "Insulin resistance",
        "Hormonal imbalances",
        "Chronic stress and cortisol spikes",
        "Sedentary lifestyle",
        "Poor sleep and recovery",
        "Overeating or cravings"
      ]
    }
  ],
  symptoms: [
    "Unexplained weight gain",
    "Sugar cravings or constant hunger",
    "Low energy and fatigue",
    "Difficulty losing fat despite exercise",
    "Mood swings and irritability"
  ],
  treatment: {
    heading: "Safe, Sustainable Weight Loss with Semaglutide",
    body: `Our program includes medical evaluations, weekly semaglutide injections, nutritional guidance, and continuous support from healthcare providers. Semaglutide mimics a natural hormone that targets areas of the brain involved in appetite regulation—helping you feel full longer, eat less, and burn more fat.

- ✅ Weekly injections with minimal side effects
- ✅ Backed by clinical trials and FDA approval
- ✅ No stimulants, no crash dieting
- ✅ Ongoing provider support

Whether you're struggling with stubborn fat, pre-diabetes, or general weight gain, this program is designed to help you succeed naturally and sustainably.`,
    image: "https://via.placeholder.com/600x400?text=Semaglutide+Treatment" // Replace with treatment image
  },
  ctaText: "Book an Appointment",
  ctaLink: "/book-appointment/"
}

};

// src/data.js
export const serviceExtras = {
  "testosterone-replacement-therapy": {
    // — Causes —
    causesIntroTitle: "What Causes Low Testosterone?",
    causesIntroText: `There are several things that could lead to a man having or developing low testosterone, or hypogonadism. Causes may be inherited, the result of a disease or health condition, due to an accident or damage, or other circumstances. Determining the underlying cause of a patient’s low testosterone is essential in deciding what treatment options would work best for them.`,
    causes: [
      {
        title: "Primary Hypogonadism",
        description: `Underactive testes are the underlying cause of primary hypogonadism. This causes the testes to underproduce the necessary amount of testosterone for a male to be healthy. The most common causes of underactive testes include:`,
        items: [
          {
            title: "Undescended Testicles",
            description: `The testicles remain in the abdomen after birth. This condition can correct itself before 4–6 months of age but requires surgery to correct after that.`
          },
          {
            title: "Hereditary Hemochromatosis",
            description: `An inherited condition that causes an excess of iron to be produced in the bloodstream which the body stores.`
          },
          {
            title: "Klinefelter’s Syndrome",
            description: `A condition that causes a male to be born with three sex chromosomes (XXY) instead of the normal two (XY).`
          },
          {
            title: "Extreme physical injury to the testicles",
            description: `Both testicles must be severely injured to inhibit testosterone production.`
          },
          {
            title: "Orchitis",
            description: `A bacterial or viral infection of the testicles, most commonly due to a sexually transmitted infection or as a result of the mumps virus.`
          },
          {
            title: "Cancer treatment",
            description: `Radiation therapy or chemotherapy can cause severe damage to the testicles.`
          }
        ]
      },
      {
        title: "Secondary Hypogonadism",
        description: `In primary hypogonadism, the damage must occur directly to the testes to cause the lack of testosterone to occur. Secondary hypogonadism, on the other hand, occurs when there is damage to the pituitary gland or the hypothalamus. Damage to these areas of the brain causes a disruption in the way that necessary hormones are produced which can lead to a lack of testosterone production.`,
        items: [
          {
            title: "Pituitary disorders",
            description: `An abnormality in the pituitary gland—often a tumor—that reduces hormone secretion. Treatment for the tumor can also cause hypogonadism.`
          },
          {
            title: "Kallmann’s Syndrome",
            description: `An abnormal development of the hypothalamus.`
          },
          {
            title: "Inflammatory diseases",
            description: `Sarcoidosis, histiocytosis, tuberculosis, and other inflammatory diseases can impact both the pituitary gland and the hypothalamus, inhibiting testosterone production.`
          },
          {
            title: "HIV/AIDS",
            description: `HIV/AIDS can directly impair hormonal regulation pathways, leading to low testosterone.`
          },
          {
            title: "Certain medications",
            description: `Opiates, illicit substances, and some hormone therapies can affect testosterone production.`
          },
          {
            title: "Obesity",
            description: `Being significantly overweight at any age, but especially during puberty, can cause hypogonadism.`
          },
          {
            title: "Aging",
            description: `After the age of 30, most men gradually produce about 1% less testosterone each year.`
          }
        ]
      }
    ],

    // — Symptoms —
    symptomsBackground: "https://i.postimg.cc/ZnHxYgqk/i-Stock-2058023631.webp",
    symptomsIntroTitle: "What Are the Symptoms of Low Testosterone?",
    symptomsIntroText: `While testosterone levels gradually decline as men age, for some men these levels can become abnormally and extremely low. Not all men with low testosterone (also known as “low T”) will exhibit symptoms, but for those that do, (TRT)testosterone replacement therapy can be an option. The most common symptoms of low testosterone levels are:`,
    symptoms: [
      "Low libido (low sex drive)",
      "Erectile dysfunction",
      "Fatigue",
      "Low energy levels",
      "Anemia (low iron levels)",
      "Decreased muscle mass",
      "Lack of or loss of body and facial hair",
      "Difficulty concentrating",
      "Depression",
      "Irritability",
      "Low self-esteem",
      "Increased weight gain"
    ],

    // — Dynamic conclusion pulled straight from data.js! —
    symptomsConclusion: `
      Frequently, the first things that men notice are a lack of energy and a low sex drive. In more severe cases of low testosterone, men may experience erectile dysfunction which can severely hinder their self‐esteem and sex life. With our telehealth (TRT)testosterone replacement therapy services, we strive to restore hormone levels, erectile function, and sexual performance, which sometimes also results in weight loss and improvement in other health conditions.
    `,
    treatment: {
      heading: "Individualized TRT Treatment for Best Results",
      image:
        "https://i.postimg.cc/jdT9hwn2/i-Stock-1213130178.webp",
      body: `Every man is different, so no two treatment paths are going to be exactly the same. We take the time to understand your unique situation and the underlying conditions that are contributing to your low testosterone.

By working with you one on one at our men’s testosterone clinic, we can help create the perfect treatment plan for you that will have you feeling young, strong, healthy, and virile again in no time. We’ll get you scheduled for labs at your earliest convenience.`
    },
    medications: {
      image: "https://i.postimg.cc/kG2511pN/i-Stock-1341077450.webp",

      heading: "Types of Testosterone Medication",
      // you can override the default hero background here if you want
      // image: "https://your.cdn/medication-hero.jpg",

      // intro copy
      paragraphs: [
        `Testosterone medications come in many different forms. While oral medications exist, they are not frequently used or recommended because there has been some evidence that oral testosterone medications can negatively affect the liver.`,
        `Instead of taking a pill every day, most testosterone medications come in the form of a skin or mouth patch, a topical gel, soft tissue implants, or injections. Depending on the type of medications you take, they may be applied daily or twice weekly.`
      ],

      // the two specific types
      types: [
        {
          title: "Gels or Creams",
          description: `Applied once per day, the gel or cream is worked directly into the skin and is absorbed.`
        },
        {
          title: "Injections",
          description: `One of the most common options, injections are done twice per week and patients administer the injections themselves.`
        }
      ],

      // final note + cta
      conclusion: `In most cases, you will be able to pick which type of medication you’d prefer, however, you should take your doctor’s advice into consideration. For some men, only certain options may be available depending on how severe their symptoms are, if they have any potential health concerns, or how low their testosterone levels are to start.`,
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment"
    },



    
    // — Benefits —
    benefits: {
      // two placeholder images; swap these URLs out when you have your real shots
      images: [
        "https://i.postimg.cc/MpjHwFtv/i-Stock-1282544143.webp",
        // not used
        "https://via.placeholder.com/600x400?text=Benefit+Image+2"
      ],
      // small “pre-heading” above the cards, if you like
      introHeading: "Benefits of Testosterone Replacement Therapy",
      // each card gets a title + array of paragraphs
      cards: [
        {
          title: "Benefits of the TRT Treatment",
          paragraphs: [
            "The benefits that a man can expect to receive at low testosterone treatment clinics(TRT) include a reduction of low T symptoms: heightened libido, improved energy levels, increased happiness, and overall better moods. Some men may also experience other physical benefits from a boost to their testosterone including muscle mass, insulin sensitivity, and bone density.",
            "Although most men will experience some combination of these benefits, not all men experience the same benefits from testosterone replacement therapy. Depending on your current testosterone levels as well as a variety of other considerations, you may experience anything from a slight boost to a massive change.",
            "It is important to remember that it takes time for testosterone replacement therapy to build up the testosterone levels in your body. Most men will begin seeing results within 3 to 6 weeks of starting treatment but the biggest results will happen around the 3-month mark."
          ]
        },
        {
          title: "Increased Happiness, Energy, and Improved Moods",
          paragraphs: [
            "Low testosterone levels have been directly linked to irritability, chronic fatigue, depression, and an overall lower quality of life. Studies have shown that testosterone replacement therapy may be an effective anti-depressant treatment option for men with hypogonadism.",
            "It is important to determine if your fatigue and depression are directly related to hypogonadism before beginning testosterone replacement therapy though. If your depression has another underlying cause, then you may not see the results that you are hoping for.",
            "Men with hypogonadism, however, should see results from their treatment and should experience a better mood, better sleep, and an overall improvement in their quality of life and enjoyment of life in 3 to 6 weeks."
          ]
        }
      ]
    },
        // — Journey / How It Works —

    // — Journey / How It Works —
    journey: {
      // CTA banner
      ctaHeading: "Start Your (TRT)Wellness Journey Today",
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment/",

      // Intro under the banner
      introHeading: "How It Works",
      introText: `(TRT)Testosterone replacement therapy, also known as androgen replacement therapy is a medically approved treatment option for patients that are experiencing hypogonadism, or low testosterone.`,

      // The 3 steps
      steps: [
        {
          number: 1,
          title: "Step One",
          icon: "https://i.postimg.cc/7ZM1mYcN/i-Stock-1387200057-2.webp",
          description: `Men are tested for low testosterone through blood tests, typically one taken early in the day and one taken just before noon. In some cases, imaging tests or additional hormone testing may be done to determine how your body is producing, or not producing, its levels of testosterone throughout the day.`
        },
        {
          number: 2,
          title: "Step Two",
          icon: "https://i.postimg.cc/J7P9dRwM/i-Stock-1387200057-3.webp",
          description: `The treatment works by prescribing men with hypogonadism a prescription amount of testosterone either as an injection or a cream. This prescription is applied either daily or twice weekly, depending on the type chosen, and most men will begin to see results within 3 to 6 weeks.`
        },
        {
          number: 3,
          title: "Step Three",
          icon: "https://i.postimg.cc/SKfZ2Gkk/i-Stock-1387200057-4.webp",
          description: `This prescription helps to increase levels of testosterone in a man’s bloodstream which leads to increased virility, stamina, strength, energy levels, mood, sexual satisfaction, and so much more.`
        }
      ]
    },
    faqs: [
      {
        question: "How Common is Low Testosterone?",
        answer: `Low testosterone is common and becomes increasingly more common as men age. 40% of men over the age of 45 have low testosterone levels, with that number increasing to 50% by age 80.

Additionally, low testosterone is more common in men with certain health conditions such as diabetes or obesity. Consistent studies have shown that between 30-50% of men with Type 2 Diabetes also have low testosterone, and 50% of obese men have low testosterone.`
      },
      {
        question: "Can I Stop Taking Testosterone Replacement Therapy When I Feel Better?",
        answer: `Testosterone replacement therapy is a long-term, and sometimes indefinite, solution to men’s hypogonadism. If you suddenly stop taking your prescription, you may begin to experience symptoms of low testosterone again as your body goes back to underproducing the amount that you need.

Most men will be able to go onto a maintenance plan by the end of their first year of testosterone therapy, however, and will only have to come in for checkups once every 6 to 12 months. This is to ensure that your prescription dosage is still working and that you’re still feeling as healthy as you should be.`
      },
      {
        question: "Who is Testosterone Replacement Therapy For?",
        answer: `Testosterone replacement therapy is not for everyone. Only men with symptomatic hypogonadism, with a testosterone level under 300 ng/dL who consistently have several of the accompanying symptoms are eligible for testosterone replacement therapy.

Low testosterone is common, affecting nearly 40% of men over the age of 45. Many men who have low testosterone will not experience any symptoms and will not require treatment for their hypogonadism.`
      },
      {
        question: "Potential Risks of Testosterone Replacement Therapy",
        answer: `The most common side effects associated with testosterone replacement therapy are rashes, itching, or irritation at the application site. Some men may also experience acne, smaller testes, and swelling of the feet or ankles. Because testosterone replacement therapy is a relatively new treatment, its long-term effects of it are still unknown.

Men with certain health conditions should be careful when starting any type of testosterone replacement therapy, as some conditions can be exacerbated during treatment. These conditions include:

• Cardiovascular disease  
• High blood pressure  
• Sleep apnea  
• Congestive heart failure  
• Enlarged prostate or prostate cancer  
• Elevated hematocrit levels (High iron)

Another potential risk is blood clots that can be caused by polycythemia, or a dramatic and abnormal increase in red blood cells. These blood clots primarily occur in the form of deep vein thrombosis or pulmonary embolism.

Additionally, men should avoid testosterone replacement therapy if they are actively trying to have children or plan to have children naturally in the future. TRT can reduce sperm counts significantly and in rare cases may cause infertility.

While this condition is typically reversible, it requires stopping (TRT)testosterone replacement therapy which can cause previous low-T symptoms to come back.`
      },
      {
        question: "When Will I See Results From (TRT)Testosterone Replacement Therapy?",
        answer: `It is natural to feel impatient when you begin testosterone replacement therapy. After all, you’ve spent months or years feeling tired and lethargic so of course, you’re ready to feel better now!

Unfortunately, testosterone replacement isn’t an overnight fix. It took years to develop low testosterone, and it takes time to rebuild it. Each person will have a different reaction to the therapy as well depending on their unique situation.

That said, most patients will begin to notice some improvements in their symptoms within 3 to 6 months, and some men may notice a change even sooner. The typical timeframes for reduction of symptoms in patients who undergo testosterone replacement therapy is:

• **3–6 Weeks:** Sex drive and libido increase while symptoms of anxiety and depression decrease. Mood elevates and energy levels increase.  
• **12–16 Weeks:** Some men begin to lose weight as fat levels decrease, inflammation in joints is relieved, and men begin to have an easier time building lean muscle mass and strength.  
• **6–12 Months:** Lipid counts decrease, bone density increases, and insulin sensitivity increases.`
      },
      {
        question: "How Long Should I Stay on (TRT)Testosterone Therapy?",
        answer: `The answer is different for everyone and it can only be determined on a case-by-case basis by your doctor. For most men, however, testosterone replacement therapy is a long-term, and in some cases indefinite process.

This is because it is often extremely difficult to treat the underlying cause of hypogonadism without testosterone replacement therapy. Men who abruptly stop treatment may begin to experience symptoms of Low-T again.

The good news is that treatment can become more of a maintenance plan once your levels have returned to normal which means that you may not have to receive the therapy as often. Your doctor will set you up with a maintenance plan and check-up schedule to ensure that your testosterone levels are remaining consistent.`
      }
    ],
  

    ctaBanner: {
      heading: "Don’t Wait to Get Relief From Your Low Testosterone Symptoms",
      body: `It takes time to get results from testosterone replacement therapy, but there’s no point in waiting for your symptoms to get worse before you seek treatment. If you are struggling with depression, lethargy, lack of motivation, a low sex drive, low muscle strength, or erectile dysfunction don’t wait any longer!
  
  Reach out to our (TRT)testosterone replacement therapy clinic team today to learn how we can help you get back to your old self. The sooner that you start testosterone replacement therapy, the sooner that you will get that boost to your energy, libido, and mood and you’ll be able to get back to doing the things you love.`,
      buttonText: "Book an Appointment",
      buttonLink: "/book-appointment/"
    },
  },

  // Add this alongside your other entries in src/data/serviceExtras.js
  "hormone-therapy-for-women": {
    // … any existing extras for causes, symptoms, etc. …

    journey: {
      ctaHeading: "Start Your Wellness Journey Today",
      ctaBody: `As hormone therapy begins to take effect in your body, you'll likely notice positive changes. Put simply, you'll feel like yourself again. Continue taking your medications and enjoy getting back to your normal life, one day at a time.`,
      ctaText:    "Book an Appointment",
      ctaLink:    "/book-appointment",

      introHeading: "How It Works: HRT for Older Women",
      introText:    "",

      steps: [
        {
          number: 1,
          icon:   "https://i.postimg.cc/bwDCJjKv/i-Stock-1387200057-5-1.webp",
          title:  "Book an Appointment",
          description:
            "Click the button at the top of the page to schedule an appointment. You can visit our clinic or set up a virtual consultation, making it easy for you to meet with a doctor who can treat your condition on your own time."
        },
        {
          number: 2,
          icon:   "https://i.postimg.cc/Z5xc0Kw4/i-Stock-1387200057-6-1.webp",
          title:  "Take Your Prescription",
          description:
            "Take your prescription as recommended by our licensed doctor. The duration of your treatment would depend on your condition. Be sure to reach out to your physician if you have any questions or concerns about your medication. Sometimes, a simple dosage adjustment can make a world of difference when it comes to your results."
        },
        {
          number: 3,
          icon:   "https://i.postimg.cc/SKfZ2Gkk/i-Stock-1387200057-4.webp",
          title:  "Live an Awesome Life",
          description:
            "It may take some time to see results, and your personal results will depend on your hormone levels, dosage, and other factors. Many women notice relief from hot flashes as soon as three weeks after the start of treatment. If you're concerned about the speed with which you're seeing results, be sure to reach out to your doctor to chat about changing your dosage."
        }
      ]
    },
    
    faqs: [
      {
        question: "How HRT May Help With Weight Gain, Night Sweats, and More",
        answer: `If you're considering starting hormone medications, it's likely that you have a lot of questions. It's smart to talk with your physician about what your hormone replacement therapy will entail so that you know what to expect as you go through the journey of getting your hormones back in order.`
      },
      {
        question: "Who can have HRT for postmenopausal women?",
        answer: `While hormone therapy works well for many women, it's not the right fit for everyone. Your doctor will work closely with you to determine whether the potential benefits outweigh the risks. Women over 60 may be at higher risk for adverse effects, and factors like a family history of blood clots, liver disease, osteoporosis, or heart disease should be taken into account.`
      },
      {
        question: "How long do I need to take HRT?",
        answer: `Your doctor will work with you to determine how long you should take hormone replacement therapy. It's generally not recommended to stay on HRT for more than a year due to an increased risk of breast cancer, though many women continue through the duration of their menopausal symptoms under close supervision.`
      }
    ],
    doctorBenefits: [
      {
        icon: "https://i.postimg.cc/CxCsQL89/i-Stock-1487309111-1-1.webp",
        title: "More Energy",
        description:
          "When you lose the energy you had in your younger years, you may feel frustrated that you aren't able to participate in the activities you enjoy. With hormone therapy, you'll likely find that you get an energy boost, making it easier for you to exercise, have positive relationships, and participate in hobbies that give your life meaning."
      },
      {
        icon: "https://i.postimg.cc/GtVnVxW3/i-Stock-1487309111-3-1.webp",
        title: "Less Fat",
        description:
          "If you're searching to learn more about HRT for women's weight loss, you're not alone. Weight gain is a common side effect of menopause. Many women who use hormone replacement therapy find that they're more easily able to lose weight. Losing fat can help boost energy and libido as well."
      },
      {
        icon: "https://i.postimg.cc/MHWYxk8d/i-Stock-1487309111-2-1.webp",
        title: "Higher Libido",
        description:
          "Many women find that they experience a decrease in sex drive when they go through menopause. HRT can help you get the fire back that you once had, boosting your sex drive and helping you enjoy intimacy the way you once did."
      },
      {
        icon: "https://i.postimg.cc/Zqs9n13w/i-Stock-1487309111-4-1.webp",
        title: "Sharper Mind",
        description:
          "Memory issues are an unfortunately common part of menopause. It can be frustrating when your mind doesn't feel as sharp as it once was. Women who take hormone replacement treatments often find that their minds feel sharper than they did prior to taking hormones."
      }
    ]
  },


  "erectile-dysfunction-treatment": {
    causesIntroTitle: "What Causes Erectile Dysfunction?",
    causesIntroText: `There are several underlying conditions, medications, and psychological causes for erectile dysfunction. Although erectile dysfunction tends to be more common in men over the age of 40 than it is in younger men, there is no direct correlation between aging and erectile dysfunction. Many men believe that low testosterone is the primary contributing factor to ED, but that is almost never the case. While hypogonadism can indirectly contribute to erectile dysfunction, in most cases there is usually a more severe health condition at the root of ED.`,

    causes: [
      {
        title: "Physical Causes",
        // an array of paragraphs before the list
        description: [
          "Physical causes are the most common reason behind erectile dysfunction.",
          "The most common physical causes of ED include:"
        ],
        items: [
          { title: "Lack of blood flow to the penis", description: `High blood pressure, narrowed arteries (from high cholesterol or diabetes), and smoking can all restrict penile blood flow, preventing an erection.` },
          { title: "Inability to retain blood",       description: `Even with adequate inflow, some men cannot trap sufficient blood in the penis to maintain an erection long enough for intercourse.` },
          { title: "Nerve damage",                    description: `Disease, inflammation, infections or severe injury can damage penile nerves so that signals can’t trigger an erection.` },
          { title: "Cancer treatments",               description: `Surgery, radiation or chemotherapy for prostate, colorectal or bladder cancer may injure nerves or blood vessels needed for erections.` },
          { title: "Cardiovascular disease",          description: `Coronary artery disease, low HDL, or high cholesterol directly impede your ability to achieve an erection.` },
          { title: "Other chronic illnesses",         description: `Type 2 diabetes, renal failure, prostate problems, hypogonadism, multiple sclerosis and similar disorders can all contribute to ED.` },
          { title: "Sleep disorders",                 description: `Obstructive sleep apnea and chronic insomnia disrupt hormonal balance and blood flow, impacting sexual function.` },
          { title: "Peyronie’s disease",              description: `Scar tissue under the penile skin causes painful curvature that makes erections difficult.` },
          { title: "Drug or alcohol abuse",           description: `Heavy alcohol use, opioids or illicit drugs impair nerve and vascular function over time.` }
        ],
        // paragraphs after the list
        additionalText: [
          "Additionally, obesity is a significant factor in erectile dysfunction, as 79% of men presenting with symptoms of ED have a BMI over 25.",
          "Men with a BMI over 30 are three times as likely to experience erectile dysfunction as men who maintain a healthy weight."
        ],
        
      },

      {
        title: "Emotional Causes",
        description: [
          "While less common than physical factors, psychological issues can trigger or worsen ED:",
          "Doctors used to believe that ED was primarily psychological, but we now know underlying physical problems are more prevalent."
        ],
        items: [
          { title: "Stress",             description: `Chronic worries—work, family, finances or relationship pressures—can block the mind–body signals needed for arousal.` },
          { title: "Depression",         description: `Untreated depression saps self-image and desire, making it harder to achieve or maintain erections.` },
          { title: "General anxiety",    description: `Excessive worry about life events distracts from sexual cues and performance.` },
          { title: "Performance anxiety",description: `A history of “bad” sexual experiences can create a self-fulfilling fear of failure.` },
          { title: "Inexperience",       description: `Lack of familiarity with sexual activity can itself provoke anxiety and ED.` },
          { title: "Guilt or shame",     description: `Feeling judged by a partner for your preferences can create emotional blocks to arousal.` },
          { title: "Low self-esteem",    description: `Body-image issues or past sexual regrets can undermine confidence in the bedroom.` }
        ]
      },
           // ← new group ↓
           {
            title: "Medication-Related Causes",
            description: [
              "Finally, several medications have listed side effects that can cause temporary erectile dysfunction in the men who take them.",
              "These medications include:"
            ],
            items: [
              { title: "Blood pressure medications" },
              { title: "Medications for prostate cancer (antiandrogens)" },
              { title: "Prescription sedatives and tranquilizers" },
              { title: "Appetite suppressants and diet pills" },
              { title: "Ulcer medications" },
              { title: "Diuretics" },
              { title: "Medications for Parkinson’s disease" },
              { title: "Antidepressants" },
              { title: "Muscle relaxors" },
              { title: "Anti-seizure medications" },
              { title: "Certain anti-inflammatory medications" },
              { title: "Medication for irregular heartbeats (antiarrhythmics)" }
            ],
            additionalText: [
              "Unfortunately, many of these medications are for chronic conditions (often prescribed by your primary care doctor or specialists). It can be difficult to switch to another medication, but it is worth discussing with your erectile dysfunction doctor and your primary care physician, who will each review your medical history.",
              "Luckily, there are plenty of treatment options for erectile dysfunction focused on increasing blood flow that will not interfere with these medications as long as you are otherwise healthy enough to enjoy sex."
            ],
            ctaText: "Book an Appointment",
            ctaLink: "/book-appointment/"
          }
    ],

    
    treatmentOptions: {
      heading: "Types of Treatment Options",
      // break your long intro into paragraphs:
      intro: [
        `There are a wide variety of treatment options available to men who have erectile dysfunction (ED), including prescription medication, penile injections, vascular reconstructive surgery, reducing fatigue, use of a vacuum erection device, and other treatments. These treatments may vary depending on if you have any underlying conditions that could be affected by medication.`,
        `Your doctor will work with you directly to determine the best treatment plan for your situation and symptoms. Typically, erectile dysfunction treatment begins by getting your cardiovascular health under control. They may recommend some lifestyle changes first, such as changing your diet (a healthy diet is essential), lowering blood sugar, exercising more, quitting smoking or drinking, overall health, or switching your current medications.`,
        `If your doctor believes that your erectile dysfunction and sexual problems may be the result of an emotional or psychological condition, they may recommend counseling or therapy. Once these considerations have been addressed, your doctor will then move on to non-invasive treatment options, typically beginning with oral medications, as long as they won’t interfere with any other medications that you may be taking.`,
        `⚠️ If you develop and maintain an erection lasting longer than 4 hours with any of these medications or treatment methods, immediately seek medical attention at your nearest emergency room. If left untreated, prolonged erections can lead to priapism which can cause permanent damage to the penis.`
      ],
      subsections: [
        {
          title: "Oral Medications",
          body: [
            `Oral medications for erectile dysfunction are the most common and traditionally successful treatment option for men with ED. Known as PDE type-5 drugs, these medications help increase blood flow to the penis in order to achieve and maintain an erection long enough for sexual intercourse.`,
            `These medications do not automatically cause erections by themselves. Instead, they help stimulate the nerves in the penis that are responsible for causing an erection. Sexual stimulation is needed to help stimulate the nitric oxide chemical that helps control penile function.`
          ],
          list: [
            "Sildenafil (Viagra)",
            "Tadalafil (Adcirca, Cialis)"
          ],
          footnotes: [
            `80% of men who take PDE type-5 medications have positive results when these pills are taken 15 minutes to 36 hours, depending on the medication, prior to intercourse.`,
            `It is essential that you tell your doctor if you are taking any other medications for chronic health conditions, particularly nitrate drugs, alpha-blockers, or medications for hypotension or hypertension. This combination of medications can cause severe and potentially life-threatening side effects. For men that are not taking any of the above medications, PDE type-5 medications are generally safe. You may experience some mild side effects including facial flushing, headaches, indigestion, muscle aches, and a stuffy nose. These reactions are typically mild and only last for a short time.`
          ]
        },
        {
          title: "Testosterone Replacement Therapy",
          body: [
            `For some men with severe hypogonadism—a condition that causes abnormally low levels of testosterone—testosterone replacement therapy may be helpful in reducing the symptoms that can cause erectile dysfunction.`,
            `In most cases, however, hypogonadism alone is not enough to cause erectile dysfunction. You should speak with your doctor about other possible underlying conditions before beginning testosterone replacement therapy.`
          ]
        }
        // …you can add “Penile Injections”, “Surgery”, etc. the same way…
      ]
    },
    




    // — Benefits — exactly the same format as TRT
    benefits: {
      // e.g. two illustrative images
      images: [
        "https://i.postimg.cc/3rSZ3GN4/Mix-Collage-24-Apr-2025-10-07-PM-5584.webp",
        "https://example.com/benefit-image-2.jpg"
      ],
      introHeading: "Benefits of Treating Erectile Dysfunction",
      cards: [
        {
          title: "Improved Sexual Performance",
          paragraphs: [
            "Easier and longer-lasting erections on demand.",
            "Greater confidence in your ability to perform.",
            "More spontaneous and satisfying sexual experiences."
          ]
        },
        {
          title: "Enhanced Well-Being",
          paragraphs: [
            "Reduced anxiety, stress, and depression related to ED.",
            "A healthier relationship with your partner and yourself.",
            "Better overall quality of life, thanks to restored self-esteem."
          ]
        }
      ]
    },

    // — Journey / How It Works — same shape as TRT
    journey: {
      ctaHeading: "Start Your Wellness Journey Today",
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment/",

    },

   // — Frequently Asked Questions —
   faqs: [
    {
      question: "How Common is Erectile Dysfunction?",
      answer: `Although erectile dysfunction is not frequently discussed in public or in social situations, it is more common than most people think. It is estimated that 52% of men experience erectile dysfunction at some point in their lives.

Erectile dysfunction is more common in men aged 40–75, but it is still possible in younger men. While doctors used to believe that erectile dysfunction was largely a psychological condition, current research suggests that in the majority of cases erectile dysfunction is caused by physical health problems.

Most commonly, it is due to a lack of proper blood supply to the penis. In some cases, this can also serve as an early warning of an underlying cardiovascular disease such as a hardening or narrowing of the arteries, high blood pressure, high cholesterol, or heart disease.

It is important to note that although erectile dysfunction is extremely common, it is not a normal part of aging. Aging is linked with declining testosterone levels, but this normal aging process does not directly affect a man’s ability to get an erection.`
    },
    {
      question: "How Do Doctors Determine the Underlying Cause of Erectile Dysfunction?",
      answer: `First, your doctor will determine if you have any underlying medical conditions—such as diabetes, an injury, cardiovascular disease, etc.—that could be causing your erectile dysfunction. In most cases of erectile dysfunction, there will be a health condition that is contributing to your symptoms that should be treated first.

Your doctor will take a full medical history to determine when the symptoms first started, and then they will perform a physical exam to see if there is a lack of sensation or any visible damage to your sex organs. For most patients, a medical history and physical exam are all that are required to get an erectile dysfunction diagnosis.

If no clear cause emerges, your doctor may then order additional tests—blood or urine work, or an ultrasound—to check for internal damage or issues with blood flow.`
    },
    {
      question: "Questions You May Be Asked",
      answer: `When you arrive for your appointment, be prepared to answer questions about your condition and symptoms to help your doctor properly diagnose you. Common questions include:

• Do you have any chronic health conditions?  
• When did your symptoms begin?  
• Have you had changes in sexual desire?  
• Are you having emotional or relationship problems?  
• Do you get erections when sleeping, masturbating, or with a partner?  
• Have you been diagnosed with a mental health condition?  
• Are you experiencing depression, anxiety, or high stress?  
• How often do your ED symptoms occur?  
• Do you drink alcohol or use illicit drugs? How often?  
• Are you taking any medications or supplements?  
• Do you smoke?  
• Have you had surgery, radiation, or chemotherapy in your pelvic region?  
• Have you had any significant injury to your pelvic area?  
• Do you have difficulty ejaculating or reaching climax?  
• Are your erections painful?  
• What is the frequency, quality, and duration of your erections like?

While some of these questions may feel awkward, they’re essential to getting you the right diagnosis and treatment. Your doctor’s goal is to help—not judge—so answer as openly as you can.`
    }
  ],

  ctaBanner: {
    heading: "Don’t Wait to Get Relief From Your Erectile Dysfunction",
    body: `Contact us today to learn about your treatment options and how quickly we can help you overcome your erectile dysfunction!`,
    buttonText: "Book an Appointment",
    buttonLink: "/book-appointment"
  }





    // … your other sections (symptoms, treatment, etc.) …
  },
  
  "benefits-of-peptide-therapy": {
    // … any existing extras …

    naturallyOccurringPeptides: {
      heading: "Naturally Occurring Peptides",
      intro: [
        `It’s important to understand that, though peptide drug development and peptide drug discovery is now in the news, the body has naturally occurring peptides throughout that you might have already heard about.`,
        `From neuropeptides in the brain, to other peptides in the immune system, there’s virtually no area of the body that doesn’t have peptides or that can’t benefit from peptide treatments.`,
        `Some of the most common peptides you might have heard of already include:`
      ],
      items: [
        {
          title: "Oxytocin",
          description:
            "A neuropeptide that helps in stimulating the uterus during labor, but also plays a role in pleasure, forming bonds, and intimacy."
        },
        {
          title: "Secretin",
          description:
            "Which helps stimulate the stomach’s acids to process food."
        },
        {
          title: "Antimicrobial peptides (AMPs)",
          description:
            "Which help fight off diseases and are one of the first lines of defense in the immune response against viruses, bacteria, and more."
        },
        {
          title: "Insulin",
          description:
            "Which is responsible for the processing of glucose in the body. Insulin resistance and lack of insulin in the body leads to diabetes."
        },
        {
          title: "Glucagon",
          description:
            "Which helps with overall health and controlling the management of the body’s cellular process, diabetes management, regulating metabolism, and more."
        }
      ],
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment"
    },

    whyUsePeptideTherapy: {
      heading: "Why Do People Use Human Growth Hormone Peptide Therapy?",
      body: `As you can see from the list above, these small molecules play a vital role in helping the body and in modern medicine. Today, bioactive peptides and natural peptides in the body are making waves as more and more scientists work to create new peptide drugs to help improve overall health.`,
      cards: [
        {
          icon: "https://i.postimg.cc/Zqs9n13w/i-Stock-1487309111-4-1.webp", // placeholder—replace when you have the real one
          title: "Peptide Therapy for Improved Cognitive Function",
          description: `Recently, scientists have been able to develop peptides made of d amino acids that have been shown to possibly help inhibit Alzheimer's disease, which is a neurological disease that affects memory. These d amino acids were once thought to be non-existent until amino acid residues of this peptide sequence were found in nature. Today, this is a new form of peptides that scientists are just beginning to understand.`
        },
        {
          icon: "https://i.postimg.cc/65s1T5Cm/i-Stock-1487309111-5-1.webp",
          title: "Peptide Therapy for Hair Growth",
          description: `For those that want a solution for hair loss, want to stimulate hair growth, and need something that works fast, there's an unfortunately low number of prescription drugs that can help. However, recent studies in Korea have shown that a peptide, APN5, has been shown to stimulate hair growth. You can also find peptides in a wide range of different uses such as oral medications, hair serums, and other therapeutic agents.`
        },
        {
          icon: "https://i.postimg.cc/brPkcM23/i-Stock-1487309111-7-1.webp",
          title: "Weight Loss Peptide Therapy",
          description: `There are also new studies that show promising peptide drugs that can be used for weight loss. This new peptide, known as AD9604, has been shown in animal studies to help reduce weight gain. In addition, because it has a safe peptide drug design, there is hope that this peptide can be used with in vivo stability as a potentially safe option for peptide therapy weight loss and weight management.`
        },
        {
          icon: "https://i.postimg.cc/s2cR4G4x/i-Stock-1487309111-2-3.webp",
          title: "Peptide Therapy for Sexual Dysfunction",
          description: `One peptide, known as bremelanotide, is one of the most recent FDA-approved peptide drugs to help treat low libido in women and help with sexual dysfunction! There are also peptide drugs available to help men with lower libido and sexual dysfunction improve their quality of life.`
        },
        {
          icon: "https://i.postimg.cc/BbD3DYY9/i-Stock-1487309111-6-2-1.webp",
          title: "Anti-Aging Peptide Therapies",
          description: `Anti-aging peptides have also been used safely to help minimize the look of the aging process. Peptide injections can help boost hormone production, as well as be injected directly into the skin to help get rid of wrinkles, and also stimulate collagen production.`
        }
      ]
    },

    howDoesPeptideWork: {
      // placeholder image—just reuse it for now, you can replace later
      image: "https://i.postimg.cc/0Ncm5gnG/Mix-Collage-24-Apr-2025-09-19-PM-3010.webp",
      heading: "How Does Peptide Therapy Work?",
      paragraphs: [
        "If you’re interested in starting peptide therapy, you’ll first need to meet with one of our providers that specializes in peptide therapies. You will be given a bloodwork exam to determine if you have any underlying conditions, and also to determine if you’re suitable for peptide therapy.",
        "Afterward, you will receive a unique and customized plan to help you get started on your road to overall better health. You might be prescribed small molecule drugs, medium sized peptides, subcutaneous injections, or a combination of different peptides in order to achieve your goals.",
        "Whether you need help with weight management or weight loss, want better skin health, are feeling tired, or want help to improve joint pain and are looking for the latest in regenerative medicine, peptides can provide a fast solution."
      ],
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment"
    },
    faqs: [
      {
        question: "What Are Peptides?",
        answer: `Naturally occurring peptides are made of building blocks of the human body. They are made up of two to ten amino acids, which string together and create peptides. However, you might see peptides made up of around 50 to 100 amino acids. When more amino acid chains are linked together, these are no longer peptides and are considered proteins in the scientific community. Peptides can be strings or cyclic peptides which are, as the name suggests, shaped in a circle. Both of these are considered simple structures and can be manufactured in a lab, unlike protein structures.`
      },
      {
        question: "The Role of Peptides in the Human Body?",
        answer: `Peptide drug discovery is now playing a key role in medicine. That's because peptides have an important role in the human body. Some of their many functions include:

• Regulate cellular processes  
• Facilitate biochemical processes in the human body  
• Help tissues grow, survive, and function`
      },
      {
        question: "How Long Will I Take Peptide Therapeutics?",
        answer: `Your peptide therapy sessions might last between 10 minutes to two hours depending on your goals. However, you might also be given peptide medications to take home with you. This will depend on the types of goals you have in mind, the severity of your condition (obesity, hair loss, pain, etc.), and recommendations made by your peptide therapy specialist.`
      },
      {
        question: "Does Peptide Therapy Have Risks?",
        answer: `It's good to know that amino acids are naturally occurring in the body. Like natural proteins, there's little risk that they'll do any harm once inside the body. Because peptides are short-chain amino acids, they can easily pass through the cell membrane and be absorbed into the body, so they can begin acting right away.

However, once they are dissolved into the body, they become simple amino acids that are then treated the same as food. In addition, cyclic peptides are now being studied for their potential to last longer in the bloodstream, giving you better results and minimizing the need for frequent dosing. Although peptide cyclization is rarer, these peptides have the potential to be more stable and are an exciting new development in peptide therapy.

In the meantime, our team will help you find the best peptide therapy that works for you and your goals using the latest in peptide drugs and pharmaceuticals.`
      }
    ],
    ctaBanner: {
      heading: "Visit Pure Health and Wellness for Peptide Therapy to Change your Life",
      body: `Whether you’re looking for pain relief, peptide therapy for weight loss, need to improve your overall health, or are even looking to fix issues like hair loss and aging, we can help you get fast results! Call us today to book an appointment with one of our experts, and experience the benefits of peptide drugs today!`,
      buttonText: "Book an Appointment",
      buttonLink: "/book-appointment"
    }
  },  

  "platelet-rich-plasma-treatment": {
    whyDoIt: {
      introLabel: "WHY DO IT",
      heading: "Benefits of Platelet Rich Plasma Treatments",
      subheading: "Many people prefer plasma rich platelet therapy because it provides numerous benefits, including the following.",
      items: [
        {
          icon: "https://i.postimg.cc/CxCsQL89/i-Stock-1487309111-1-1.webp",
          title: "Faster Recovery",
          description:
            "The procedure is performed in a doctor’s office with local anesthesia so you can return home soon after."
        },
        {
          icon: "https://i.postimg.cc/RhFBpCZm/i-Stock-1484981265-1-1.webp",
          title: "Less Bruising",
          description:
            "Because there’s no incision or surgery involved, there won’t be any noticeable scarring or bruising afterward."
        },
        {
          icon: "https://i.postimg.cc/65s1T5Cm/i-Stock-1487309111-5-1.webp",
          title: "Stimulates Hair Growth",
          description:
            "PRP scalp injections promote collagen formation and blood flow, stimulating hair growth by increasing cell production within the follicle."
        },
        {
          icon: "https://i.postimg.cc/BbD3DYY9/i-Stock-1487309111-6-2-1.webp",
          title: "Reduces Wrinkles",
          description:
            "PRP treatment reduces the appearance of skin aging, resulting in a more youthful look in a short period without going under the knife."
        },
        {
          icon: "https://i.postimg.cc/RhsMv6Dq/i-Stock-1487309111-8-1.webp",
          title: "Minimizes Scars",
          description:
            "With PRP injections, you can minimize these marks without invasive procedures like dermabrasion or laser therapy."
        },
        {
          icon: "https://i.postimg.cc/6pxPy5xQ/i-Stock-1487309111-9-1-1.webp",
          title: "Natural Procedure",
          description:
            "Since PRP uses your blood, the procedure is perfect for people who don’t want to use synthetic substances."
        }
      ]
    },
    faqs: [
      {
        question: "How does platelet rich plasma treatment work?",
        answer: `Platelets are important for clotting and healing injured tissue. When the PRP is injected into your skin, it causes an inflammatory reaction that draws more white blood cells to the area in question.

This process makes sense because it’s what your body does naturally when there’s an injury or trauma to an area of the skin.`
      },
      {
        question: "Does plasma rich platelet therapy hurt?",
        answer: `A small amount of discomfort may be felt when PRP gets injected into the skin, but most patients don’t experience any pain. The plasma rich platelet therapy procedure is performed with a topical anesthetic cream and local anesthesia to help minimize discomfort.`
      },
      {
        question: "How long does a plasma rich platelet therapy take?",
        answer: `The entire plasma rich platelet therapy takes about 30 minutes, but you will need to plan for one hour in case you have any questions or concerns after your treatment.`
      }
    ],
    journey: {
      ctaHeading: "Start Your Wellness Journey Today",
      ctaText: "Book an Appointment",
      ctaLink: "/book-appointment/",
      introHeading: "Our Simple Process",
      introText: "", // no extra intro paragraph
      steps: [
        {
          number: 1,
          icon:   "https://i.postimg.cc/bwDCJjKv/i-Stock-1387200057-5-1.webp",
          title:  "Book an appointment",
          description:
            "Click the button at the top of the page to schedule an appointment. You can visit our clinic or set up a virtual consultation."
        },
        {
          number: 2,
          icon:   "https://i.postimg.cc/Z5xc0Kw4/i-Stock-1387200057-6-1.webp",
          title:  "Take your prescription",
          description:
            "Take your prescription as recommended by our licensed doctor. The duration of your treatment would depend on your condition."
        },
        {
          number: 3,
          icon:   "https://i.postimg.cc/SKfZ2Gkk/i-Stock-1387200057-4.webp",
          title:  "Live an awesome life",
          description:
            "Some people see results sooner than others, but one thing is for sure: it works. You’ll have more energy to live the life that you want."
        }
      ]
    }
    // … any other extras like faqs, ctaBanner, etc. …
  },

  "pain-management": {
    ctaBanner: {
      heading: "Quality of Life",
      body: `The clinic also offers Electodiagnostic testing and consultations in medical-legal cases such as car accidents and slip and falls. Pure Health & Wellness will continue to treat anti-aging and lifestyle issues such as testosterone replacement, weight loss, erectile dysfunction, and sleep dysfunction.`,
      buttonText: "Book an Appointment",
      buttonLink: "/book-appointment"
    }
  },
"semaglutide-weight-loss-program": {
  benefits: {
    images: [
      "https://i.postimg.cc/3rSZ3GN4/Mix-Collage-24-Apr-2025-10-07-PM-5584.webp"
    ],
    introHeading: "Why Choose Semaglutide?",
    cards: [
      {
        title: "Noticeable Weight Reduction",
        paragraphs: [
          "Achieve lasting weight loss with a solution that’s tailored to work with your body."
        ]
      },
      {
        title: "Appetite Control",
        paragraphs: [
          "Feel satisfied longer, making it easier to stick with healthy choices."
        ]
      },
      {
        title: "Metabolic Support",
        paragraphs: [
          "Boost your metabolism and maintain healthy blood sugar levels for optimal wellness."
        ]
      }
    ]
  },
  ctaBanner: {
    heading: "Join Our Program Today starting at only $229/Month!",
    body: `When you start with us, you’re not just getting Semaglutide; you’re gaining a supportive, expert-led team dedicated to your success. At Pure Health & Wellness, our team will guide you with:

• Personalized Plans
• Compassionate Support
• Ensuring You Achieve The Results You Deserve

Start your journey toward a healthier you!

Starting $229/Month includes medication up to 1mg dosage, supplies, and access to wellness provider. Dosage of 1.75mg and up is an additional $70. Shipping not included.`,
    buttonText: "Book an Appointment",
    buttonLink: "/book-appointment"
  },
  journey: {
    ctaHeading: "Start Your Journey Toward Lasting Weight Loss",
    ctaText: "Book an Appointment",
    ctaLink: "/book-appointment",
    introHeading: "How It Works",
    introText: "Our process is simple, personalized, and designed to help you succeed with medically guided Semaglutide treatment.",
    steps: [
      {
        number: 1,
        title: "Medical History",
        icon: "https://res.cloudinary.com/djtsuktwb/image/upload/v1749869037/iStock-1387200057_5_uxdsyl.jpg",
        description: "Fill out a simple medical history questionnaire to help your provider create a personalized treatment plan tailored to your needs. The process is quick, straightforward, and entirely free."
      },
      {
        number: 2,
        title: "Online Consultation",
        icon: "https://res.cloudinary.com/djtsuktwb/image/upload/v1749869099/iStock-1487309111_1_1_kpij8z.jpg",
        description: "Connect with a licensed physician or nurse practitioner to discuss your condition. Conveniently meet online, on your schedule, without leaving the comfort of your home."
      },
      {
        number: 3,
        title: "Receive Your Medication",
        icon: "https://res.cloudinary.com/djtsuktwb/image/upload/v1749869071/iStock-1387200057_6_xw7ytr.jpg",
        description: "Your prescribed medication will be delivered straight to your doorstep with free shipping included in all plans. Reach out to your provider anytime for follow-ups or additional support."
      }
    ]
  }
}

};


export const locationsData = {
  "fresno": {
    name: "Fresno Clinic",
    address: "349 E. Bullard Ave Suite 105, Fresno, CA 93710",
    addressMaps: "https://www.google.com/maps/place/349+E+Bullard+Ave+Suite+105,+Fresno,+CA+93710",
    heroImage: "https://i.postimg.cc/cH87kgqY/i-Stock-588965234-1.webp",
    desktopImage: "https://i.postimg.cc/8kXQW90w/i-Stock-588965234-2.webp",
    description: "Our Fresno clinic offers testosterone replacement therapy (TRT), hormone therapy for women, erectile dysfunction treatment, peptide therapy, PRP (platelet-rich plasma) therapy, Semaglutide weight-loss program, and a full range of advanced pain treatments.",
    phone: "(877) 271-0203",
    fax: "(800) 887-1723",
    email: "referrals@californiapremierpainclinics.com",
    hours: "Mon - Fri: 08:00 AM - 05:00 PM, Sat - Sun: Closed"
  }
};